/* TGC Gear — footer link columns collapse on a phone.

   Progressive enhancement: with no script the columns render open, which is
   the correct fallback — a footer that needs script to reveal its links is
   a footer whose links are invisible to anything that does not run it.

   The three columns are found by the block ids given to them in
   sections/footer-group.json. Renaming a block there means renaming it here;
   nothing else in the file knows about footer content. */
(() => {
  const COLUMNS = [
    ['__csh', '__csl'],
    ['__cuh', '__cul'],
    ['__cah', '__cal'],
  ];
  const PHONE = '(max-width: 749px)';

  const find = (sub) =>
    document.querySelector(`.footer-content [class*="${sub}"]`);

  const pairs = COLUMNS.map(([h, p]) => ({ head: find(h), panel: find(p) })).filter(
    (x) => x.head && x.panel
  );
  if (!pairs.length) return;

  pairs.forEach((pair, i) => {
    const label = pair.head.textContent.trim();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'tgc-footer__toggle';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', `tgc-footer-panel-${i}`);
    // The heading's own markup becomes the button's label, so the type
    // settings the merchant chose on that text block still apply.
    button.innerHTML = pair.head.innerHTML;
    pair.head.replaceChildren(button);
    pair.panel.id = `tgc-footer-panel-${i}`;
    pair.button = button;

    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      pair.panel.hidden = open;
    });
  });

  const mq = window.matchMedia(PHONE);
  const apply = () => {
    const phone = mq.matches;
    document.querySelector('.footer-content').classList.toggle('tgc-footer--accordion', phone);
    pairs.forEach(({ panel, button }) => {
      // Off a phone every panel is open and the button is inert, so a
      // resize can never strand a column closed and unreachable.
      panel.hidden = phone ? button.getAttribute('aria-expanded') !== 'true' : false;
      button.disabled = !phone;
    });
  };
  apply();
  mq.addEventListener('change', apply);
})();
